var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showicd10modal
      ? _c(
          "div",
          [
            _c("transition", { attrs: { name: "modal" } }, [
              _c("div", { staticClass: "modal-mask" }, [
                _c("div", { staticClass: "modal-wrapper" }, [
                  _c("div", { staticClass: "modal-container modal-width500" }, [
                    _c("div", { staticClass: "modal-body p-0" }, [
                      _c("div", { staticClass: "pb-3 pr-3 pl-3" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12 px-0" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "close-sec-hold",
                                staticStyle: { right: "-15px", top: "-15px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "close d-close",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("cancelAction")
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("close"),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "h5",
                              { staticClass: "text-center mt-3 mb-3 m-0" },
                              [_vm._v("ICD10")]
                            ),
                            _vm._t("body", function () {
                              return [
                                _vm.viewillnessdata &&
                                _vm.viewillnessdata.length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _vm._l(
                                          _vm.viewillnessdata,
                                          function (item) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row container-list",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-12 immuni-dl50",
                                                  },
                                                  [
                                                    _c("dl", [
                                                      _c("dt", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SelectedCodes"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "dd",
                                                        [
                                                          _vm._v(": "),
                                                          _vm._l(
                                                            item.selected_code,
                                                            function (
                                                              data,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                [
                                                                  data.code
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data.code
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  index <
                                                                  data.code
                                                                    .length >
                                                                  0
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            ", "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]),
                                                    _c("dl", [
                                                      _c("dt", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("Problems")
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "dd",
                                                        [
                                                          _vm._v(": "),
                                                          _vm._l(
                                                            item.selected_code,
                                                            function (
                                                              data,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "span",
                                                                [
                                                                  data.name
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data.name
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  index <
                                                                  data.name
                                                                    .length >
                                                                  0
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            ", "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-12 sec-div-line immuni-dl50",
                                                  },
                                                  [
                                                    item.starting_date
                                                      ? _c("dl", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Startdate"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _c("dd", [
                                                            _vm._v(
                                                              ": " +
                                                                _vm._s(
                                                                  item.starting_date
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    item.ending_date
                                                      ? _c("dl", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Enddate"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _c("dd", [
                                                            _vm._v(
                                                              ": " +
                                                                _vm._s(
                                                                  item.ending_date
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    item.occurences
                                                      ? _c("dl", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Occurrences"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _c("dd", [
                                                            _vm._v(
                                                              ": " +
                                                                _vm._s(
                                                                  item.occurences
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ])
                                                      : _c("dl", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Occurrences"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _c("dd", [
                                                            _vm._v(": N/A "),
                                                          ]),
                                                        ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm.viewillnessdata.notes_item
                                          ? _c(
                                              "div",
                                              { staticClass: "row w-100" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-md-12 mt-3",
                                                  },
                                                  [
                                                    _c(
                                                      "dl",
                                                      {
                                                        staticClass:
                                                          "immuni-dldt100",
                                                      },
                                                      [
                                                        _c("dt", [
                                                          _vm._v("Comments"),
                                                        ]),
                                                        _c("dd", [
                                                          _vm._v(
                                                            ": " +
                                                              _vm._s(
                                                                _vm
                                                                  .viewillnessdata
                                                                  .notes_item
                                                              ) +
                                                              " "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n                          No ICD10 data has been entered yet\n                        "
                                      ),
                                    ]),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [_vm._t("footer")],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }